import React from "react";

import "../styles.scss";
import "../scripts";

import {
  primaryBlock,
  PrimaryBlockConfig,
  getDefaultProps,
  KameleonElement,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  BlockType,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";

import { webflowHOC } from "@kameleon-common/webflow-js";
import { Variants } from "@kameleon-util/global-theme";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { SliderType, layoutOptions } from "./types/prop-types";
import getEvents from "./js/webflow";

/** Slider Primary */
const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.None,
  tertiaryBlockSize: TertiaryBlockSize.None,
  blockType: BlockType.Primary,
  blockTheme: BlockTheme.dark,
};

export const SliderComponent = ({
  header,
  description,
  images,
  _internalProps,
  layoutProps,
}: SliderType) => (
  <Box
    className={
      _internalProps?._className ?? "primary-slider-media-full-width-v1"
    }
  >
    <Box className="section_gallery13">
      <Box className="padding-global">
        <Box className="container-large">
          <Box className="padding-section-large">
            <Box className="text-align-center">
              <Box className="max-width-large align-center">
                <Box className="margin-bottom margin-small">
                  <Variants.Heading>{header}</Variants.Heading>
                </Box>
                <Variants.ParagraphMedium>
                  {description}
                </Variants.ParagraphMedium>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className="gallery13_component">
        <Variants.Slider
          layoutProps={layoutProps}
          className="gallery13_slider w-slider"
        >
          <Box className="gallery13_mask w-slider-mask">
            {Variants.AllowedRandomItems(layoutProps, images)?.map(
              (image, index) => (
                <Box
                  key={index}
                  className="gallery13_slide w-slide"
                  data-w-id={_internalProps?._fade && "slide"}
                >
                  <Box className="gallery13_image-wrapper">
                    <Variants.Image
                      src={image.url}
                      loading="lazy"
                      sizes="100vw"
                      alt={image.alt}
                      className="gallery13_image"
                    />
                  </Box>
                </Box>
              )
            )}
          </Box>
          <Variants.LinkButtonSliderMedia
            left
            className="gallery13_arrow is-left w-slider-arrow-left"
          />
          <Variants.LinkButtonSliderMedia
            left={false}
            className="gallery13_arrow w-slider-arrow-right"
          />
          <Variants.SliderNav className="gallery13_slide-nav w-slider-nav w-round" />
        </Variants.Slider>
      </Box>
    </Box>
  </Box>
);

const SliderComponentWithWebflow = webflowHOC(SliderComponent, [
  {
    module: "ix2",
    getEvents: (pageId: any): any => getEvents(pageId),
  },
  "slider",
]);

export const Slider = primaryBlock<SliderType>(
  blockConfig,
  SliderComponentWithWebflow
);
Slider.defaultProps = getDefaultProps<SliderType>(defaults);

export const Element: KameleonElement = {
  component: Slider,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
